import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { Bestsellers } from '../components/Bestsellers';
import { ProductLines } from '../components/ProductLines';
import { WhyChamaleon } from '../components/WhyChamaleon';
import { PartnerCTA } from '../components/PartnerCTA';
import { NewsSection } from '../components/NewsSection';
import { ContactForm } from '../components/ContactForm';
import { MobileApp } from '../components/MobileApp';
import { Footer } from '../components/Footer';
type Language = 'ua' | 'en';
export function HomePage() {
  const [language, setLanguage] = useState<Language>('ua');
  return <div className="min-h-screen bg-chamaleon-black" data-id="element-357">
      <Header language={language} onLanguageChange={setLanguage} data-id="element-358" />
      <main data-id="element-359">
        <Hero language={language} data-id="element-360" />
        <TrustStrip language={language} data-id="element-361" />
        <Bestsellers language={language} data-id="element-362" />
        <ProductLines language={language} data-id="element-363" />
        <WhyChamaleon language={language} data-id="element-364" />
        <PartnerCTA language={language} data-id="element-365" />
        <NewsSection language={language} data-id="element-366" />
        <ContactForm language={language} data-id="element-367" />
        <MobileApp language={language} data-id="element-368" />
      </main>
      <Footer language={language} onLanguageChange={setLanguage} data-id="element-369" />
    </div>;
}